import React, { Component } from 'react'
import Client from '../Client'
import BlackLoading from '../images/black-loader.gif';
import {Carousel} from 'react-bootstrap';

class ContainerDesignFlashImages extends Component {
  constructor(props) {
    super(props)
    this.state = {
         containerdesignflashpage:[]
    }
}

componentDidMount(){
    Client.getEntries({
        'content_type': 'containerdesignFlashImages',

    }).then((entries)=>{
        this.setState({containerdesignflashpage: entries.items})
    });
}


render() {
  return (
    <>
        {this.state.containerdesignflashpage.length === 0 ?
              <div align="center"><img src={BlackLoading} alt="Loading..." /></div> :
        <Carousel fade={false}>
          
          {this.state.containerdesignflashpage.map((item, index) => {
            return(
            <Carousel.Item key={index}>
            <img
              className="d-block w-100"
              src={item.fields.containerdesignFlashImagesImg.fields.file.url}
              alt="sam bridge container design slide"
            />
            <Carousel.Caption>
                <span className="slidefont">{item.fields.containerdesignFlashImagesTitle}</span>
            </Carousel.Caption>
            </Carousel.Item>
                  )
                  })}
        </Carousel>
        }

    </>
    )
  }
}

export default ContainerDesignFlashImages;


